
export default (entity, labelKey, valueKey) => entity.map(item => (
    {
        label: item[labelKey],
        value: item[valueKey]
    }
));
